// extracted by mini-css-extract-plugin
export var icon = "common-module--icon--FbIJY";
export var link = "common-module--link--5NHuH";
export var text = "common-module--text--4yHcZ";